export const waText = (code) => (code ? `Hi, my coupon code is ${code}` : "Hi");

export const waLink = (number, code) => `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(waText(code))}`;
